import { action, makeObservable, observable } from "mobx";
import { setSessionJson, getSessionJson } from '../utils/SessionService';
import { privatePost } from "../utils/NetworkService";




class MiningState {
    id;
    mining_second;
    need_clover;
    reward_stand;
    mining_limit_count;
    remain_minig_count;
    clover_count;
    constructor(miningData) {
        this.id = miningData?.mining_item?.id ?? null;
        this.mining_second = miningData?.mining_item?.mining_second ?? null;
        this.need_clover =  miningData?.mining_item?.need_clover ?? null;
        this.reward_stand = miningData?.mining_item?.reward_stand ?? null;
        this.mining_limit_count = miningData?.mining_item?.mining_limit_count ?? null;
        this.remain_minig_count = miningData?.remain_minig_count ?? null;
        this.clover_count = miningData?.clover_count ?? null;
    }
}


class UserMiningListState {
    mined_stand;
    mined_second;
    mined_count;
    remain_count;
    remain_second;
    remain_clover;
    constructor(MiningListData) {
        this.mined_stand = MiningListData?.mined_stand ?? null;
        this.mined_second = MiningListData?.mined_second ?? null;
        this.mined_count =  MiningListData?.mined_count ?? null;
        this.remain_count = MiningListData?.remain_count ?? null;
        this.remain_second = MiningListData?.remain_second ?? null;
        this.remain_clover = MiningListData?.remain_clover ?? null;
    }
}



class TimeBarState {
        remain_second;
        TimeBarValue;
        constructor(UserMiningCompleteStoreData) {
            this.remain_second = UserMiningCompleteStoreData?.remain_second ?? null;
            this.TimeBarValue = UserMiningCompleteStoreData?.remain_clover ?? null;
        }
    }




export class MiningStore {
    rootStore;
    MiningState = getSessionJson('MiningState') ? new MiningState(getSessionJson('MiningState'), null) : new MiningState();
    UserMiningListState = getSessionJson('UserMiningListState') ? new UserMiningListState(getSessionJson('UserMiningListState'), null) : new UserMiningListState();
    TimeBarState = getSessionJson('TimeBarState') ? new TimeBarState(getSessionJson('TimeBarState'), null) : new TimeBarState();



    
    MiningCount = 1;
    MiningCloverCount = 1000;
    MiningTime = 180;
    TimeBarValue = 0;
    RemainSecondMin = 0;
    RemainSecondSec = 0;
    RemainSecondHour = 0;
    RemainSecond = 0;

    MiningErrorMassage = "";

    StandMiningData = [];
    UserMiningListData  = [];
    MiningHistoryData = [];
    
    constructor(root){
        makeObservable(this,{
            MiningCount: observable,
            MiningCloverCount: observable,
            MiningTime: observable,
            StandMiningData:observable,
            MiningErrorMassage:observable,
            UserMiningListData:observable,
            TimeBarValue:observable,
            RemainSecondMin:observable,
            RemainSecondSec:observable,
            RemainSecondHour:observable,
            RemainSecond:observable,
            MiningHistoryData:observable,









            setMiningHistoryData:action,
            getMiningHistory:action,
            setRemainSecondHour:action,
            setTimeBarValue:action,
            setRemainSecondSec:action,
            setRemainSecondMin:action,
            setRemainSecondTime:action,
            setTimeBar:action,
            setMiningPageReset:action,
            setUserMiningListData:action,
            setErrorMassage:action,
            // setUserMiningCompleteStore:action,
            getUserMiningComplete:action,
            setUserMiningListState:action,
            setStandMiningData:action,
            getStandMining:action,
            setMiningDialogReset:action,
            setMiningTime:action,
            setMiningCloverCount:action,
            setMiningCount:action,
        });
        this.rootStore= root;
        this.MiningState = getSessionJson('MiningState') ? new MiningState(getSessionJson('MiningState'), null) : new MiningState();
        this.UserMiningListState = getSessionJson('UserMiningListState') ? new UserMiningListState(getSessionJson('UserMiningListState'), null) : new UserMiningListState();
        this.TimeBarState = getSessionJson('TimeBarState') ? new TimeBarState(getSessionJson('TimeBarState'), null) : new TimeBarState();





        this.MiningCount = 1;
        this.MiningCloverCount = 1000;
        this.MiningTime = 180;
        this.TimeBarValue = 0;
        this.RemainSecondMin = 0;
        this.RemainSecondSec = 0;
        this.RemainSecondHour = 0;
        this.RemainSecond = 0;




        this.MiningErrorMassage = "";

        this.StandMiningData = [];
        this.UserMiningListData  = [];
        this.MiningHistoryData = [];



    }


    setMiningCount = (value) => {
        // console.log(value);
        const remainCount = this.UserMiningListData.remain_count;
        // console.log("setMiningCountRemainCount",remainCount);
        if(value === "+" ) {
            this.MiningCount = this.MiningCount + 1;
        }
        else if (value === '-'){
            this.MiningCount = this.MiningCount - 1;
        }
         // eslint-disable-next-line
        if(remainCount != 0) {
            let count = 50 - Number(remainCount);
            if(this.MiningCount >= count) {
                this.MiningCount = count
            }
        }
        if(this.MiningCount > 50) {
            this.MiningCount = 50;
        }
        else if(this.MiningCount < 0) {
            this.MiningCount = 1;
        }
        this.setMiningCloverCount(this.MiningCount);
        this.setMiningTime(value);
    }


    setMiningCloverCount(miningTime) {
        // console.log(miningTime);
        if(this.MiningCount) {
            this.MiningCloverCount = miningTime + "000";
        }
        else if(this.MiningCount < 0) {
            this.MiningCloverCount = 1000;
        }
    }



    setMiningTime(Plama) {
        if(Plama === "+") {
            this.MiningTime = this.MiningTime + 180;
        }
        else if(Plama === "-") {
            this.MiningTime = this.MiningTime - 180;
        }

        if(this.MiningCount < 0) {
            this.MiningTime = 180;
        }
        else if(this.MiningCount === 1) {
            this.MiningTime = 180;
        }

        if(this.MiningTime > 9000 ) {
            this.MiningTime = 9000;
        }
    }

    getMimingItemList = () => {//채굴데이터 불러오기
        const api = "/getMiningItemList";
        privatePost({ api: api, data: {member_no : this.rootStore.loginStore.loginState.member_no }}, (err, response) => {
            if(err){
                // console.log(err);
            }
            else {
                // console.log(response?.data?.result);
                // console.log("getMimingItemList",response?.data?.result);
                if(response?.data?.result) {
                    this.setMiningInfoState(response?.data?.result);
                    if(response?.data?.result?.mining_item.mining_second){
                        this.setMiningTime(response?.data?.result?.mining_item.mining_second);
                    }
                }
            }
        });
    }



    getStandMining = (value) => {//채굴시작
        const api = "/startStandMining";
        privatePost({ api: api, data:  {member_no : this.rootStore.loginStore.loginState.member_no, mining_count: this.MiningCount} }, (err, response) => {
            if (err) {
                // console.log(err); 
                // console.log(err.errorCode);
                if(err.errorCode === 2401 ) {
                    this.setErrorMassage(this.rootStore?.loginStore?.ErrorGuide_clover_coin_006);//클로버가 부족합니다
                }
                if(err.errorCode === 3506) {
                    this.setErrorMassage(this.rootStore?.loginStore?.ErrorGuide_3506);//최대50회까지 가능합니다
                }
                if(err.errorCode === 501) {
                    this.setErrorMassage(this.rootStore?.loginStore?.ErrorGuide_501);//잠시 후 다시 시도해주세요
                }
            } 
            else {
                // console.log("채굴시작",response?.data?.result);
                this.setStandMiningData(response?.data?.result);
                this.setMiningPageReset();
                this.rootStore.loginStore.getCloverCount();
                this.getUserMiningList("Start");
                this.setErrorMassage("NO");
                }
        });
    }


    getUserMiningList = (value) => {//수령데이터 불러오기
        // console.log(value);
        const api = "/getUserMiningList";   
        if(value !== undefined){
            privatePost({ api: api, data:  {member_no : this.rootStore.loginStore.loginState.member_no }}, (err, response) => {
                if (err) {
                    // console.log(err); 
                } 
                else {
                // console.log("수령데이터",response?.data?.result);

                    this.setUserMiningListData(response?.data?.result);
                    this.setUserMiningListState(response?.data?.result);
                    this.setRemainSecondTime(response?.data?.result);
                    this.setTimeBarValue(response?.data?.result.remain_second);
                    // setSessinInt(response?.data?.result);
                    }
            });
        }
        else {
            // console.log("undefinedGood");
            return
        }

    }

    getUserMiningComplete = () => {//수령 완료 버튼
        const api = "/userMiningComplete";
        privatePost({ api: api, data:  {member_no : this.rootStore.loginStore.loginState.member_no }}, (err, response) => {
            if (err) {
                // console.log(err); 
                if(err.errorCode === 3501 ){
                    return alert(this.rootStore?.loginStore?.ErrorGuide_3501);//채굴정보가 없습니다
                }
                else if(err.errorCode === 3505 ){
                    return alert(this.rootStore?.loginStore?.ErrorGuide_3505);//완료된 채굴이 없습니다
                }
            }
            else {
                // console.log("수령 완료",response?.data?.result);
                // console.log("getUserMiningComplete",response?.data?.result);
                this.setUserMiningListData(response?.data?.result);
                this.rootStore.CoinStore.getDBCoin();
                this.setUserMiningListState(response?.data?.result);
                }
        });
    }


    setErrorMassage(value) {
        if(value === "NO"){
        this.MiningErrorMassage = "";
        }
        else{
            this.MiningErrorMassage = value;
        }
    }


    setStandMiningData(object) {
        this.StandMiningData = object;
    }



    setMiningDialogReset() {
        this.MiningErrorMassage = "";
        this.MiningCount = 1;
        this.MiningCloverCount = 1000;
        this.MiningTime = 180;
        this.rootStore.loginStore.isMiningButton = 0;
    }

    setMiningPageReset() {
        this.MiningErrorMassage = "";
        this.MiningCount = 1;
        this.MiningCloverCount = 1000;
        this.MiningTime = 180;
    };

    setUserMiningListData(object) {
        this.UserMiningListData = object;
    };

    setMiningInfoState(miningData) {
        this.MiningState = new MiningState(miningData);
        if (miningData)
            setSessionJson('MiningState', miningData);
    };


    setUserMiningListState(MiningListData) {
        // console.log(UserMiningListData);
        this.UserMiningListState = new UserMiningListState(MiningListData);
        if (MiningListData)
            setSessionJson('UserMiningListState', MiningListData);
        
    }

    /** 새로고침시 MiningBar 값 구하기*/
    setTimeBarValue(value) {
        // const remain_second = this.UserMiningListState?.remain_second;
        const remain_second = value;
        const remain_count = this.UserMiningListState?.remain_count;
        const remain_second_Count = 180 * remain_count;
        const TimeCount = remain_second_Count - remain_second;
        if(parseInt(TimeCount) !== 180) {
            const TimeValue = Math.round(TimeCount/1.8);
            this.TimeBarValue = TimeValue ;
        }
        // else if(parseInt(TimeCount) === 180) {
        //     // this.getUserMiningList();
        // }
        if(this.TimeBarValue === 100 ) {
            this.TimeBarValue = 0;
        }
        else{
            this.setTimeBar(1);
        }
    }


    /**MiningBar 값 변경 */
    setTimeBar(value) {
        // console.log(value);
        // console.log(this.TimeBarValue);
        if(this.TimeBarValue < 100) {
            this.TimeBarValue = this.TimeBarValue + value;
        }
        else if( this.TimeBarValue === 100 ){
            this.TimeBarValue = 0;
        }
        if(this.UserMiningListData.remain_count === 0) {
            this.TimeBarValue = 0;
        }
        if(parseInt(this.RemainSecondMin) === 0) {
            if(parseInt(this.RemainSecondSec) === 0) {
                this.TimeBarValue = 0;
            }
        }
    }

    getMiningHistory = () => {
        const api = "/getMiningHistory";
        privatePost({ api: api, data:  {member_no : this.rootStore.loginStore.loginState.member_no }}, (err, response) => {
            if (err) {
                // console.log(err); 
            }
            else {
                // console.log(response?.data?.result);
                this.setMiningHistoryData(response?.data?.result);
                }
        });
    } 

    setMiningHistoryData(object) {
        // console.log(object.slice(0,20));
        this.MiningHistoryData = object.slice(0,20);
    }


    setRemainSecondTime(value) {
        // console.log(value);
        this.RemainSecondHour = parseInt(value.remain_second/3600);
        this.RemainSecondMin = parseInt((value.remain_second%3600)/60);
        this.RemainSecondSec = value.remain_second%60;
        this.RemainSecond = value.remain_second;
    }

    setRemainSecondHour(value) {
        this.RemainSecondHour = value
    }

    setRemainSecondMin(value) {
        this.RemainSecondMin = value
    }

    setRemainSecondSec(value) {
        this.RemainSecondSec = value
    }

}